import {Box, Grid, Typography, Button} from '@mui/material';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import AutoField, {ActionType} from '../../components/AutoForm/AutoFieldNew';
import {FixedFooter} from '../../components/Layout/Layout';
import Loading from '../../components/Loading/Loading';
import {LeadFormValues, leadTypeField, singleJointField} from './addAccountFields';
import {useAddAccountContext} from './AddAccountContext';
import {SingleAddressForm} from './AddExtAccountAddress';
import {AddLeadPerson} from './AddAccountBasic';

import {FormReadOnly} from '../../components/AutoForm/AutoFormNew';
import {useDjangoContext} from '../../contexts/useAuthContext';
import {themeColors} from '../../theme/Theme';

import {useDebugContext} from '../../contexts/DebugProvider';
import {useAutoForm, useAutoField} from '../../components/AutoForm/useAutoForm';

export const AddAccountSummaryForm: React.FC = () => {
  const navigate = useNavigate();
  const [_, initialMeta] = useAutoField('initial');
  const {perms} = useDjangoContext();
  const {goToStep, onCreateOrUpdateLoading, saving} = useAddAccountContext();
  const {closeSnackbar, enqueueSnackbar} = useSnackbar();
  const {debug} = useDebugContext();
  useEffect(() => {
    goToStep('summary');
  }, []);
  const {values, handleSubmit, setErrors, setFormikState} = useAutoForm<LeadFormValues>();
  if (saving) {
    return <Loading spinner>Creating client</Loading>;
  }

  return (
    <>
      <Box mt={1} mb={1} padding={3} bgcolor="white">
        <Grid container spacing={2}>
          <Grid item xs={12} md={8} lg={6}>
            <FormReadOnly readOnly={!debug?.forms} emptyValText=" ">
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <Typography variant="h4">Client Summary:</Typography>
                </Grid>
                <Grid item>
                  <AutoField field={leadTypeField} />
                </Grid>
                <Grid item>
                  <AutoField field={singleJointField} />
                </Grid>
                <Grid item>
                  <Typography variant="h6">Primary client details:</Typography>
                </Grid>
                <AddLeadPerson personType="primary" />
                <Box mt={4} />
                {values.singleJoint === 'joint' ? (
                  <>
                    <Typography variant="h6">Secondary client details:</Typography>
                    <AddLeadPerson personType="secondary" />
                  </>
                ) : null}
                <Box mt={4} />
                <Grid item>
                  <Typography variant="h6">Address:</Typography>
                </Grid>
                <Grid item>
                  <SingleAddressForm readOnly />
                </Grid>
              </Grid>
              <Box mt={2} />
              <Box mt={2} />
            </FormReadOnly>
            <FixedFooter>
              <Box mt={0.5} />
              <Box display="flex">
                <Box
                  mr={2}
                  width={270}
                  border={`1px solid ${themeColors.grey}`}
                  display="flex"
                  justifyContent="center"
                >
                  <strong>
                    <AutoField
                      field={{
                        type: ActionType.checkboxToggle,
                        id: 'agree',
                        label: 'I agree',
                      }}
                    />
                  </strong>
                </Box>
                <Grid item>
                  <Typography>
                    I understand that Saltus has not completed any assessment of the
                    suitability of the proposed plans for the clients’ circumstances, and
                    that the responsibility for both initial and ongoing suitability
                    remains with us. Additionally, I confirm that the client(s) has agreed
                    to the Saltus Platform Terms & Conditions and Saltus’ Fees & Charges
                    schedule.
                  </Typography>
                </Grid>
              </Box>
              <Box mt={2} />
              <Grid justifyContent="space-between" container>
                <Button
                  onClick={() => navigate('../address')}
                  variant="contained"
                  color="primary"
                >
                  Back
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  disabled={saving || !values.agree}
                  onClick={() => {
                    closeSnackbar();

                    handleSubmit();
                  }}
                >
                  {saving ? 'Submitting...' : 'Submit'}
                </Button>
              </Grid>
            </FixedFooter>
          </Grid>
        </Grid>
      </Box>

      <Box mt={10} />
    </>
  );
};
